module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-dialog', {
    attrs: {
      "visible": _vm.showModal,
      "width": "500px",
      "close-on-press-escape": false,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.showModal = $event
      }
    }
  }, [_c('span', {
    staticClass: "modal-title",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("REENVIAR LEMBRETE DE ASSINATURA")]), _vm._v(" "), _c('el-alert', {
    attrs: {
      "title": "Confirmação",
      "type": "warning",
      "description": _vm.descricao,
      "show-icon": "",
      "closable": false
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loadingSave
    },
    on: {
      "click": _vm.enviar
    }
  }, [_vm._v("Enviar")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        _vm.showModal = false
      }
    }
  }, [_vm._v("Cancelar")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-46d1b9ae"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/web/consulta/liberacao/_includes/lembrete-assinatura.vue
// module id = 1469
// module chunks = 45